// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"611":"ff53bcbc","787":"040b6295","919":"eaf98323"}[chunkId] + ".chunk.js";
};